import React, { useEffect, useState } from "react";
import { Table, Spin, Popover, notification } from "antd";
import moment from "moment";
import { useAuth } from "services/Auth";
import PageLayoutWrapper from "components/PageLayoutWrapper";
import { offlineHandler } from "utils/offlineCache";

function MobileSchedule() {
  const [tableData, setTableData] = useState([]);
  const [currentWeek, setCurrentWeek] = useState([]);
  const [loading, setLoading] = useState(true);
  const [weekOffset] = useState(0);
  const { auth } = useAuth();
  const apiClient = offlineHandler(auth.data);

  const daysOfWeek = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

  useEffect(() => {
    generateWeek(weekOffset);
  }, [weekOffset]);

  useEffect(() => {
    if (currentWeek.length > 0) {
      loadData();
    }
  }, [currentWeek]);

  const generateWeek = (offset = 0) => {
    const today = moment().add(offset, "weeks");
    const startOfWeek = moment(today).startOf("isoWeek");
    const weekDays = daysOfWeek.map((day, index) => moment(startOfWeek).add(index, "days"));
    setCurrentWeek(weekDays);
  };

  const getWeekRangeText = () => {
    if (currentWeek.length === 0) return "";
    const start = moment(currentWeek[0]).format("DD-MM");
    const end = moment(currentWeek[6]).format("DD-MM");
    return `${start}  a   ${end}`;
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const staffResponse = await apiClient.getMany("/staff");
      if (staffResponse.status === false) {
        notification.error({
          message: "Erro",
          description: "Erro ao carregar os funcionários",
        });
        await apiClient.post("/error-capture", {
          error: staffResponse.data,
          action: "/MobileSchedule/loadData/ getMany /staff",
          timestamp: new Date().toISOString(),
        });
        return;
      }

      const weekStart = moment(currentWeek[0]).startOf("day");
      const weekEnd = moment(currentWeek[6]).endOf("day");
      const occupationsRes = await apiClient.getMany("/staff/occupations");

      if (occupationsRes.status === false) {
        notification.error({
          message: "Erro",
          description: "Erro ao carregar as ocupações",
        });
        await apiClient.post("/error-capture", {
          error: occupationsRes.data,
          action: "/MobileSchedule/loadData/ getMany /staff/occupations",
          timestamp: new Date().toISOString(),
        });
        return;
      }
      const occupations = occupationsRes.data.filter((occupation) => {
        const occStart = moment(occupation.start_date);
        const occEnd = moment(occupation.end_date);

        return (
          staffResponse.data.some((staff) => occupation.staff?._id === staff._id) &&
          ((occStart.isSameOrAfter(weekStart) && occStart.isSameOrBefore(weekEnd)) ||
            (occEnd.isSameOrAfter(weekStart) && occEnd.isSameOrBefore(weekEnd)) ||
            (occStart.isBefore(weekStart) && occEnd.isAfter(weekEnd)))
        );
      });

      //const totals = await loadStaffTotals(staffResponse.data);

      processDataForTable(staffResponse.data, occupations);
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "Erro",
        description: "Erro ao carregar os funcionários",
      });
      await apiClient.post("/error-capture", {
        error: error,
        action: "/MobileSchedule/loadData/catch",
        timestamp: new Date().toISOString(),
      });
    } finally {
      setLoading(false);
    }
  };

  // NOT NEEDED?
  // const loadStaffTotals = async (staffList) => {
  //   try {
  //     const yearStart = moment().startOf("year").toDate();
  //     const weekStart = moment(currentWeek[0]).subtract(1, "day").endOf("day").toDate();

  //     const filter = {
  //       date$range: [yearStart, weekStart],
  //     };

  //     const totals = await apiClient.getMany("/totals", { params: { filter } });

  //     const groupedByStaff = {};

  //     totals.data
  //       .filter((item) => item.code.name !== "Trabalho")
  //       .forEach((item) => {
  //         if (item.code.name === "Banco de horas") item.code.name = "BH";
  //         const staffId = item.staff._id;
  //         const occupationCode = item.code.name;
  //         const duration = item.duration;

  //         if (!groupedByStaff[staffId]) {
  //           groupedByStaff[staffId] = {};
  //         }

  //         if (!groupedByStaff[staffId][occupationCode]) {
  //           groupedByStaff[staffId][occupationCode] = 0;
  //         }

  //         groupedByStaff[staffId][occupationCode] += duration;
  //       });

  //     //setStaffTotals(groupedByStaff);
  //     return groupedByStaff;
  //   } catch (error) {
  //     console.error("Error fetching totals:", error);
  //     return {};
  //   }
  // };

  const processDataForTable = (staff, occupations) => {
    const data = staff.map((staffMember) => {
      const row = {
        key: staffMember._id,
        staffName: staffMember.name,
        //totals: totals[staffMember._id] || {},
      };

      daysOfWeek.forEach((day, index) => {
        row[`day${index}`] = [];
      });

      occupations.forEach((occupation) => {
        if (occupation.staff?._id === staffMember._id && occupation.start_date) {
          const occStartDate = moment(occupation.start_date);
          const occEndDate = moment(occupation.end_date);

          currentWeek.forEach((weekDay, index) => {
            const dayStart = moment(weekDay).startOf("day");
            const dayEnd = moment(weekDay).endOf("day");

            if (occStartDate.isSameOrBefore(dayEnd) && occEndDate.isSameOrAfter(dayStart)) {
              row[`day${index}`].push(occupation);
            }
          });
        }
      });
      return row;
    });
    setTableData(data);
  };

  const formatTime = (isoString) => moment(isoString).format("HH:mm");

  const renderOccupationCell = (occupations) => {
    if (!occupations || !Array.isArray(occupations) || occupations.length === 0) {
      return "-";
    }

    return (
      <div style={{ fontSize: "10px" }}>
        {occupations.map((occ, idx) => {
          if (!occ || typeof occ !== "object") {
            return (
              <div key={`invalid-${idx}`} style={{ color: "red" }}>
                inválido
              </div>
            );
          }

          const codeName = occ.code && occ.code.name ? occ.code.name : "N/A";
          const shiftName = occ?.shift?.name;
          const startDate = occ.start_date ? formatTime(occ.start_date) : "N/A";
          const endDate = occ.end_date ? formatTime(occ.end_date) : "N/A";

          if (codeName === "Trabalho") {
            return (
              <div
                key={idx}
                style={{
                  padding: "2px 0",
                  borderBottom: idx < occupations.length - 1 ? "1px dashed #f0f0f0" : "none",
                }}
              >
                <div style={{ fontWeight: "bold" }}>{shiftName}</div>
                <div>{occ?.role?.name}</div>
                <div>{occ?.workplace?.name}</div>
                <div>
                  {startDate}-{endDate}
                </div>
              </div>
            );
          } else {
            return (
              <div
                key={idx}
                style={{
                  padding: "2px 0",
                  borderBottom: idx < occupations.length - 1 ? "1px dashed #f0f0f0" : "none",
                }}
              >
                <div style={{ fontWeight: "bold" }}>{codeName}</div>
                <div>{shiftName}</div>
                {!occ.is_full_day && (
                  <div>
                    {startDate}-{endDate}
                  </div>
                )}
              </div>
            );
          }
        })}
      </div>
    );
  };

  const generateColumns = () => {
    const staffColumn = {
      title: "Staff",
      dataIndex: "staffName",
      key: "staffName",
      width: 80,
      render: (_, record) => (
        <div
          style={{
            fontSize: "10px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "80px",
          }}
        >
          <Popover content={record.staffName} placement="right" trigger="click">
            {record.staffName}
          </Popover>
        </div>
      ),
    };

    const dayColumns = daysOfWeek.map((day, index) => {
      const dayDate = currentWeek[index];
      const isToday = dayDate ? moment().isSame(dayDate, "day") : false;

      return {
        title: () => (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div>{day}</div> <div style={{ fontWeight: 400 }}>&nbsp;- </div>
            <div
              style={{
                fontWeight: 400,
                borderRadius: "50%",
                backgroundColor: isToday ? "#1890ff" : "transparent",
                color: isToday ? "white" : "inherit",
                width: "15px",
                height: "15px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "10px",
                marginTop: "1px",
              }}
            >
              {dayDate ? dayDate.date() : ""}
            </div>
          </div>
        ),
        dataIndex: `day${index}`,
        key: `day${index}`,
        width: 60,
        render: renderOccupationCell,
        className: isToday ? "today-column" : "",
      };
    });

    return [staffColumn, ...dayColumns];
  };

  const columns = generateColumns();

  return (
    <PageLayoutWrapper title={`Escala Semanal ${getWeekRangeText()}`}>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
          <Spin size="default" />
        </div>
      ) : (
        <div style={{ width: "100%", overflowX: "auto" }}>
          <Table
            className="mobile-schedule-table"
            dataSource={tableData}
            columns={columns}
            pagination={false}
            // scroll={{ x: "max-content", y: "90vh" }}
            size="small"
            bordered
            sticky={{ offsetHeader: 0 }}
            style={{ maxWidth: "100%" }}
          />
        </div>
      )}
    </PageLayoutWrapper>
  );
}

export default MobileSchedule;
